import React, { useEffect, useMemo, useState } from 'react';
import useToolbarSetter from '../../hooks/Common/useToolbarSetter';
import { ReportItemInList } from '../../web_api/models';
import getReportsList from '../../web_api/methods/reports/getReportsList';
import { Accordion } from 'react-bootstrap';
import moment from 'moment';
import { Tooltip } from 'react-tooltip';
import LoadingPage from '../../layout/LoadingPage';
import postReport from '../../web_api/methods/reports/postReport';
import downloadIcon from '../../assets/images/download_icon.png';

enum ReportType {
  Monthly = 3,
  Weekly = 2,
  Daily = 1,
}

const Reports = () => {
  const { setToolbar } = useToolbarSetter();
  useEffect(() => {
    setToolbar('reports', `Reports`);
  });

  const [reports, setReports] = useState<ReportItemInList[]>([]);
  const [groupedReports, setGroupedReports] = useState<{ [key: string]: ReportItemInList[] }>({});
  const [loading, setLoading] = useState(false);

  const loadInitialData = async () => {
    setLoading(true);
    const res = await getReportsList();
    setReports(res.reports);
    setGroupedReports(groupByMonth(res.reports));
    setLoading(false);
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    console.log(reports);
  }, [reports]);

  // Helper function to group reports by month
  const groupByMonth = (reports: ReportItemInList[]) => {
    const grouped = reports.reduce((acc, report) => {
      const month = moment(report.start_date).format('MMMM YYYY'); // Get the month name
      if (!acc[month]) {
        acc[month] = [];
      }
      acc[month].push(report);
      acc[month].sort((a, b) => moment(b.end_date).diff(moment(a.end_date)));

      return acc;
    }, {} as { [key: string]: ReportItemInList[] });

    // Sort months in descending order
    return Object.keys(grouped)
      .sort((a, b) => moment(b, 'MMMM YYYY').diff(moment(a, 'MMMM YYYY')))
      .reduce((sortedAcc, month) => {
        sortedAcc[month] = grouped[month];
        return sortedAcc;
      }, {} as { [key: string]: ReportItemInList[] });
  };

  const handleReportDownload = async (report: ReportItemInList) => {
    console.log('Downloading report', report);

    try {
      const downloadPath = await postReport(report.guid);

      // Fix backslashes in the URL if present
      const fixedDownloadPath = downloadPath.replace(/\\/g, '/');

      // Create a temporary <a> element
      const link = document.createElement('a');
      link.href = fixedDownloadPath;

      // Set the download attribute with a file name
      link.setAttribute('download', 'downloaded_report.zip'); // Use an appropriate file name

      // Append the link to the document body
      document.body.appendChild(link);

      // Programmatically trigger the click to start the download
      link.click();

      // Remove the link after triggering the download
      document.body.removeChild(link);
    } catch (error) {
      console.error('Failed to download report', error);
    }
  };

  return (
    <div className='w-100 d-flex flex-column gap-5 px-10 py-5'>
      <span className='fs-3'>Manager Reports</span>
      {/* Showcase the grouped reports by month one for each accordion */}
      {loading ? (
        <LoadingPage />
      ) : (
        <>
          {Object.keys(groupedReports).map((month, index) => (
            <Accordion defaultActiveKey='0' className='mt-3 w-100'>
              <Accordion.Item eventKey={String(index)} key={index} className='w-100' style={{ border: 'none' }}>
                <Accordion.Header
                  className='mx-0 mb-1 rounded w-100 custom-accordion-header-class-invoices px-2'
                  style={{ backgroundColor: '#EDF4FF' }}
                >
                  <span className='fs-4 fw-bold' style={{ color: '#1e1e2d' }}>
                    {month}
                  </span>
                </Accordion.Header>
                <Accordion.Body className='w-100 py-5'>
                  <div className='d-flex flex-row flex-wrap'>
                    {groupedReports[month].map((report) => (
                      <div className='col-md-2 col-sm-4 col-12 px-1 my-1' onClick={() => handleReportDownload(report)} style={{ cursor: 'pointer' }}>
                        <div className='fs-5 px-4 py-2 rounded-3 d-flex flex-row align-items-center' style={{ backgroundColor: '#EDF4FF' }}>
                          <div key={report.guid} className=' d-flex flex-row align-items-center justify-content-between w-100'>
                            <div className='d-flex flex-column align-items-start'>
                              {`${report.algorithm_type ? report.algorithm_type + ' - ' : ''}${
                                report.report_type === ReportType.Daily ? 'Daily' : report.report_type === ReportType.Weekly ? 'Weekly' : 'Monthly'
                              } report`}{' '}
                              {report.report_type === ReportType.Daily ? (
                                <strong>{moment(report.start_date).format('DD.MM')}</strong>
                              ) : (
                                <strong>
                                  {moment(report.start_date).format('DD.MM')} - {moment(report.end_date).format('DD.MM')}
                                </strong>
                              )}
                            </div>
                          </div>
                          <img src={downloadIcon} className='w-50px' alt='download icon' />
                        </div>
                      </div>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}
        </>
      )}
    </div>
  );
};

export default Reports;
